<template>
  <div>
    <h3 class="mb-2">Notifications</h3>
    <p>We will keep you updated on your order by sending email notifications to {{ profile.email }}. To send these notifications to more recipients, enter CC email addresses below.</p>
    <div class="flex flex-wrap mt-4 mb-8">
      <div class="w-full mb-4" :class="{'md:w-2/3': fullWidth}">
        <h4 class="mb-2 text-xs">New Recipient:</h4>
        <div class="flex">
          <input type="email" v-model="ccEmail" class="w-full border hover:border-grey-darker focus:border-grey-darkest p-3" @keyup.enter="$emit('addCc', ccEmail); ccEmail = null" />
          <button class="bg-grey-lighter hover:bg-grey-light border-t border-r border-b px-3" @click="$emit('addCc', ccEmail); ccEmail = null">Add</button>
        </div>
      </div>

      <div class="w-full">
        <h4 class="mb-2 text-xs">CC Addresses:</h4>
        <em v-if="orderItem.notification_cc.length === 0">
          No other recipients
        </em>
        <table class="w-full">
          <tbody>
            <tr v-for="(recipient, i) in orderItem.notification_cc" :key="i">
              <td>{{ recipient }}</td>
              <td class="text-right py-2">
                <i class="fas fa-times-circle text-grey-dark hover:text-grey-darkest cursor-pointer" title="Remove" @click="$emit('removeCc', recipient)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      ccEmail: null
    }
  },
  props: ['orderItem', 'fullWidth'],
  computed: {
    ...mapState(['profile'])
  }
}
</script>
